import { type PostNftExternalAddressPayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postExternalAddress } from '../data-access/api';

/**
 * @returns addRecipient mutation object
 */
export const useMyCollectibleAddRecipientMutation = () =>
	useMutation({ mutationFn: (payload: PostNftExternalAddressPayload) => postExternalAddress(payload) });
